module.exports = __webpack_public_path__ + "static/media/profilePicture.9b2a6bb1.jpg";